import LiquidezPagamentoPJQuery from "../../common/query/LiquidezPagamentoPJQuery";
import LiquidezRecebimentoPJQuery from "../../common/query/LiquidezRecebimentoPJQuery";
import MediaDiasInadimplenciaPJQuery from "../../common/query/MediaDiasInadimplenciaPJQuery";
import ScoreEvolucaoPJQuery from "../../common/query/ScoreEvolucaoPJQuery";
import TitleStripe from "../../common/TitleStripe";
import PagamentosViaBoletoPJQuery from "../PagamentosViaBoletoPJQuery";
import PagamentosViaBoletoTedPJQuery from "../PagamentosViaBoletoTedPJQuery";
import PredicaoRecebimentoBoletoPJQuery from "../PredicaoRecebimentoBoletoPJQuery";
import RecebimentosViaBoletoPJQuery from "../RecebimentosViaBoletoPJQuery";
import RecebimentosViaBoletoTedCartaoPJQuery from "../RecebimentosViaBoletoTedCartaoPJQuery";
import ConcentracaoPagamentosPJQuery from "./ConcentracaoPagamentosPJQuery";
import ConcentracaoRecebimentoPJQuery from "./ConcentracaoRecebimentoPJQuery";

export default function InformacoesFinanceirasPJQuery({ dataFull }) {
  // Flags de existência (statusRetorno == 1)
  const hasRecBoleto = dataFull?.recebimentosViaBoletoPJ?.statusRetorno == 1;
  const hasPagBoleto = dataFull?.pagamentosViaBoletoPJ?.statusRetorno == 1;
  const hasRecBoletoTedCartao =
    dataFull?.recebimentosViaBoletoCartaoTedPJ?.statusRetorno == 1;
  const hasPagBoletoTed =
    dataFull?.pagamentosViaBoletoTedPJ?.statusRetorno == 1;

  const hasConcRec = dataFull?.concentracaoRecebimentoPJ?.statusRetorno == 1;
  const hasConcPag = dataFull?.concentracaoPagamentoPJ?.statusRetorno == 1;

  const hasLiqRec = dataFull?.liquidezRecebimentoPJ?.statusRetorno == 1;
  const hasLiqPag = dataFull?.liquidezPagamentoPJ?.statusRetorno == 1;

  const hasPredicao = dataFull?.predicaoRecebimentoBoletoPJ?.statusRetorno == 1;
  const hasMediaDias = dataFull?.mediaDiasInadimpleciaPJ?.statusRetorno == 1;

  // helpers (coloque no topo do arquivo ou onde mantiver seus utils)
  const toNum = (v) => {
    if (v == null) return null; // só "nulo" bloqueia a comparação; zero é válido
    const n = Number(String(v).replace(",", "."));
    return Number.isFinite(n) ? n : null;
  };
  const brl = (v) =>
    (Number(v) || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  const pct = (v) =>
    Number.isFinite(v)
      ? v.toLocaleString("pt-BR", {
          minimumFractionDigits: 1,
          maximumFractionDigits: 1,
        })
      : null;

  // valores dos indicadores (apenas números ou null)
  const recIndic = toNum(dataFull?.recebimentosViaBoletoCartaoTedPJ?.indicador);
  const pagIndic = toNum(dataFull?.pagamentosViaBoletoTedPJ?.indicador);

  // regra: só compara se ambos NÃO forem nulos
  const showTransactedMore =
    recIndic != null && pagIndic != null && recIndic < pagIndic;
  const showTransactedPositive =
    recIndic != null && pagIndic != null && recIndic > pagIndic;
  const diffBase =
    recIndic != null && pagIndic != null
      ? recIndic < pagIndic
        ? recIndic
        : pagIndic
      : null;
  const diffPct =
    diffBase != null && diffBase > 0
      ? (Math.abs(pagIndic - recIndic) / diffBase) * 100
      : null;
  const canCompare =
    hasRecBoletoTedCartao &&
    hasPagBoletoTed &&
    recIndic != null &&
    pagIndic != null;
  const diffValue = canCompare ? recIndic - pagIndic : null;
  const diffAbs = diffValue != null ? Math.abs(diffValue) : null;
  const totalIndic = canCompare ? recIndic + pagIndic : null;
  const recPct =
    totalIndic != null && totalIndic > 0 ? (recIndic / totalIndic) * 100 : null;
  const pagPct =
    totalIndic != null && totalIndic > 0 ? (pagIndic / totalIndic) * 100 : null;
  const balanceLabel =
    !canCompare || recIndic === pagIndic
      ? "Equilíbrio"
      : recIndic > pagIndic
        ? "Entra mais"
        : "Sai mais";
  const balanceTone =
    !canCompare || recIndic === pagIndic
      ? "bg-slate-100 text-slate-600 border-slate-200"
      : recIndic > pagIndic
        ? "bg-emerald-50 text-emerald-700 border-emerald-200"
        : "bg-rose-50 text-rose-700 border-rose-200";

  // Layout helpers
  const gridClass = (both) =>
    both ? "grid gap-4 grid-cols-2" : "grid gap-4 grid-cols-1";
  const pairLayout = (both) => (both ? "half" : "full");

  return (
    <div className="flex flex-col gap-4">
      {dataFull?.scoreEvolucaoPJ?.statusRetorno == 1 && (
        <div>
          <ScoreEvolucaoPJQuery score={dataFull?.scoreEvolucaoPJ?.score} />
        </div>
      )}

      {/* Recebimentos × Pagamentos via boleto */}
      {(hasRecBoleto || hasPagBoleto) && (
        <div>
          <TitleStripe>Valor transacionado</TitleStripe>
          <div className="text-gray-600 text-sm mt-2">
            Atribuí a uma empresa um valor médio de recebimento ou pagamento em
            grupo de mesmo perfil ao longo de um período. Na composição desse
            grupo são consideradas diversas variáveis atreladas ao CNPJ
            consultado, sendo as principais: região demográfica, setor de
            mercado (CNAE) e valor de recebimento (porte).
          </div>
          <div className={gridClass(hasRecBoleto && hasPagBoleto)}>
            {hasRecBoleto && (
              <RecebimentosViaBoletoPJQuery
                strategy="even"
                closedMonths
                showTable
                data={dataFull?.recebimentosViaBoletoPJ}
              />
            )}
            {hasPagBoleto && (
              <PagamentosViaBoletoPJQuery
                // idem comentário acima
                strategy="even"
                closedMonths
                showTable
                data={dataFull?.pagamentosViaBoletoPJ}
              />
            )}
          </div>
        </div>
      )}

      {(hasRecBoletoTedCartao || hasPagBoletoTed) && (
        <div>
          <TitleStripe>Valor transacionado</TitleStripe>
          {showTransactedPositive && (
            <div className="mt-3 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm text-emerald-700">
              Recebimentos médios maiores que pagamentos ({brl(recIndic)} vs{" "}
              {brl(pagIndic)}
              {diffPct != null ? `, +${pct(diffPct)}%` : ""}).
            </div>
          )}
          {canCompare && (
            <div className="mt-3 rounded-xl border border-slate-200 bg-slate-50 px-4 py-3 shadow-sm">
              <div className="flex items-center justify-between">
                <div className="text-xs font-semibold text-slate-700">
                  Comparativo de fluxo
                </div>
                <div
                  className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold ${balanceTone}`}
                >
                  {balanceLabel}
                </div>
              </div>
              <div className="mt-3 grid gap-3 grid-cols-3 items-center">
                <div className="rounded-xl border border-emerald-200 bg-white px-3 py-3">
                  <div className="text-[10px] font-semibold text-emerald-700 uppercase tracking-wide">
                    Entradas
                  </div>
                  <div className="mt-1 text-base font-semibold text-emerald-900">
                    {brl(recIndic)}
                  </div>
                  {recPct != null && (
                    <div className="text-[11px] text-emerald-700">
                      {pct(recPct)}% do total
                    </div>
                  )}
                </div>
                <div className="rounded-xl border border-slate-200 bg-white px-3 py-3 text-center">
                  <div className="text-[10px] font-semibold text-slate-600 uppercase tracking-wide">
                    Saldo
                  </div>
                  <div
                    className={`mt-1 inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold ${balanceTone}`}
                  >
                    {balanceLabel}
                  </div>
                  {diffAbs != null && (
                    <div
                      className={[
                        "mt-2 text-sm font-semibold",
                        diffValue > 0
                          ? "text-emerald-700"
                          : diffValue < 0
                            ? "text-rose-700"
                            : "text-slate-600",
                      ].join(" ")}
                    >
                      Diferença:{" "}
                      {`${diffValue > 0 ? "+" : diffValue < 0 ? "-" : ""}${brl(
                        diffAbs,
                      )}`}
                    </div>
                  )}
                  {diffPct != null && (
                    <div className="text-[11px] text-slate-500">
                      Variação:{" "}
                      {`${diffValue > 0 ? "+" : diffValue < 0 ? "-" : ""}${pct(
                        diffPct,
                      )}%`}
                    </div>
                  )}
                </div>
                <div className="rounded-xl border border-rose-200 bg-white px-3 py-3">
                  <div className="text-[10px] font-semibold text-rose-700 uppercase tracking-wide">
                    Saídas
                  </div>
                  <div className="mt-1 text-base font-semibold text-rose-900">
                    {brl(pagIndic)}
                  </div>
                  {pagPct != null && (
                    <div className="text-[11px] text-rose-700">
                      {pct(pagPct)}% do total
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <div className={gridClass(hasRecBoletoTedCartao && hasPagBoletoTed)}>
            {hasRecBoletoTedCartao && (
              <RecebimentosViaBoletoTedCartaoPJQuery
                strategy="even"
                closedMonths
                showTable
                data={dataFull?.recebimentosViaBoletoCartaoTedPJ}
              />
            )}
            {hasPagBoletoTed && (
              <PagamentosViaBoletoTedPJQuery
                // idem comentário acima
                strategy="even"
                closedMonths
                showTable
                data={dataFull?.pagamentosViaBoletoTedPJ}
              />
            )}
          </div>
          <div className="text-gray-500 text-xs mt-2">
            Atribuí a uma empresa um valor médio de recebimento ou pagamento em
            grupo de mesmo perfil ao longo de um período. Na composição desse
            grupo são consideradas diversas variáveis atreladas ao CNPJ
            consultado, sendo as principais: região demográfica, setor de
            mercado (CNAE) e valor de recebimento (porte).
          </div>
        </div>
      )}

      {/* Predição de recebimento (full width) */}
      {hasPredicao && (
        <div>
          <TitleStripe>Predição de Valor transacionado</TitleStripe>
          <div className="text-gray-600 text-sm mt-2">
            Projeta o valor médio mensal de pagamentos ou recebimentos de uma
            empresa para os próximos 12 meses. Utilizando modelagem com
            inteligência artificial e baseado no histórico de transações da
            empresa por boletos, cartão e TED.
          </div>
          <PredicaoRecebimentoBoletoPJQuery
            strategy="even"
            closedMonths
            showTable
            data={dataFull?.predicaoRecebimentoBoletoPJ}
          />
        </div>
      )}

      {/* Concentração de Recebimento × Concentração de Pagamento */}
      {(hasConcRec || hasConcPag) && (
        <div>
          <TitleStripe>Maior Concentração</TitleStripe>
          <div className="text-gray-600 text-sm mt-2">
            Indica como está a concentração de pagamentos ou recebimentos de
            boletos para um CNPJ em relação aos seus fornecedores ou clientes.
            Este índice foi criado com base no conceitual econômico para medir o
            grau de concorrência de uma empresa.
          </div>
          <div className={`${gridClass(hasConcRec && hasConcPag)}`}>
            {hasConcRec && (
              <ConcentracaoRecebimentoPJQuery
                layout={pairLayout(hasConcRec && hasConcPag)}
                data={dataFull?.concentracaoRecebimentoPJ}
              />
            )}
            {hasConcPag && (
              <ConcentracaoPagamentosPJQuery
                layout={pairLayout(hasConcRec && hasConcPag)}
                data={dataFull?.concentracaoPagamentoPJ}
              />
            )}
          </div>
        </div>
      )}

      {hasLiqRec && (
        <LiquidezRecebimentoPJQuery
          layout={pairLayout(hasLiqRec && hasLiqPag)} // <-- agora dinâmico
          data={dataFull?.liquidezRecebimentoPJ}
        />
      )}
      {hasLiqPag && (
        <LiquidezPagamentoPJQuery
          layout={pairLayout(hasLiqRec && hasLiqPag)} // <-- agora dinâmico
          data={dataFull?.liquidezPagamentoPJ}
        />
      )}

      {/* Média de dias de inadimplência (full width) */}
      {hasMediaDias && (
        <div>
          <TitleStripe>Inadimplência</TitleStripe>
          <MediaDiasInadimplenciaPJQuery
            data={dataFull?.mediaDiasInadimpleciaPJ}
          />
        </div>
      )}
    </div>
  );
}
